import React, { useState } from 'react'
import {
    GridDropZone,
    GridItem
  } from "react-grid-dnd";
import { useSelector, useDispatch } from 'react-redux'
import {Button} from "@mui/material"
import reportbuilder from "../ReportBuilder.module.css";
import { setDimensionVal } from '../../../reduxStore/reducer';
const DropDimensionsTable = () => {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.selectedDimensions.dimensionsVal)
  console.log("items from drop dimension",items[0]);
    const removeHandeler =(clickedObj)=>{
      console.log("clickedObj from drop dimension", clickedObj);
     //remove one obj from dimension bottom
      let newBottomArr = items[0].dimensionBottom.filter((item)=>{return item.id != clickedObj.id})
      console.log("newArr inside drop dimension",clickedObj,newBottomArr);
        let newTopArr = [...items[0].dimensionTop,clickedObj]
        console.log("newTopArr", newTopArr);
      
      dispatch(setDimensionVal([
        {
          // ...items,
          ["dimensionBottom"]:newBottomArr,
          ["dimensionTop"] : newTopArr
        }
      ]
        
      ))
     }
  return (
    // <GridContextProvider onChange={onChange}>
         <div className={reportbuilder.droptable}>
         <GridDropZone
          className="dropzone"
          id="dimensionBottom"
          boxesPerRow={1}
          rowHeight={40}
          style={{height:"25vh", borderRadius:"0%", overflowY:"scroll"}}
        >
         {
          // console.log("items",items)
         items[0]?.dimensionBottom?.map(item => (
          <GridItem style={{zIndex:100}} key={item.name}>
            <div className="grid-item">
               <Button className="grid-item-content" sx={{bgcolor:"#e6ecff", color:"#000", fontSize:"11px"}} onClick={()=>removeHandeler(item)}>
               <span style={{marginRight:"0.5rem"}}>-</span>{item.name}
                </Button>
            </div>
          </GridItem>
        ))
         }
        </GridDropZone> 
</div>
 
// </GridContextProvider>
   
  )
}

export default DropDimensionsTable